function putObject(obj: Record<string, any>, path: string | string[], value: any): void {
    const stringToPath = function (path: string | string[]): string[] {
        if (!Array.isArray(path) && typeof path === 'string') {
            const output: string[] = [];

            for (const item of path.split('.')) {
                for (const key of item.split(/\[([^\]]+)\]/g)) {
                    if (key) {
                        output.push(key);
                    }
                }
            }

            return output;
        }

        return path;
    };

    const keys = stringToPath(path);

    let current: Record<string, any> = obj;

    for (let index = 0; index < keys.length; index++) {
        const rawKey = keys[index];
        const isArray = rawKey.endsWith('[]');
        const key = isArray ? rawKey.slice(0, -2) : rawKey;

        if (isArray && !Array.isArray(current[key])) {
            current[key] = [];
        }

        if (index === keys.length - 1) {
            if (isArray) {
                current[key].push(value);
            } else {
                current[key] = value;
            }
        } else {
            if (current[key] === undefined || current[key] === null) {
                current[key] = {};
            }
            current = current[key];
        }
    }
}

// ----------------------------------------------------------------------------

export default putObject;
